export const handleEventDate = date => {
  const dd = date.getUTCDate();
  const mm = date.getUTCMonth() + 1;

  return [dd, mm];
};
